import { enqueueSnackbar, type OptionsObject } from 'notistack';

type NotifyOptions = Omit<OptionsObject, 'variant'>;

/**
 * Imperative notification API for use **outside** React components
 * (middleware, services, listeners, etc). Inside components prefer
 * the `useNotify()` hook.
 *
 * Works because `notistack` exposes a standalone `enqueueSnackbar`
 * that routes to the nearest `SnackbarProvider` at runtime.
 */
export const notify = {
  success(message: string, options?: NotifyOptions): void {
    enqueueSnackbar(message, { ...options, variant: 'success' });
  },
  error(message: string, options?: NotifyOptions): void {
    enqueueSnackbar(message, { ...options, variant: 'error' });
  },
  warning(message: string, options?: NotifyOptions): void {
    enqueueSnackbar(message, { ...options, variant: 'warning' });
  },
  info(message: string, options?: NotifyOptions): void {
    enqueueSnackbar(message, { ...options, variant: 'info' });
  },
};
